import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";

const SERVICES_API = "https://backenddev.aaerlaw.com/api/user/paraclearth_services";

function truncateText(text, maxLen = 300) {
  if (!text || text.length <= maxLen) return text;
  const trimmed = text.slice(0, maxLen);
  const lastSpace = trimmed.lastIndexOf(" ");
  return (lastSpace > 0 ? trimmed.slice(0, lastSpace) : trimmed) + "...";
}

function ServiceSection() {
  const [services, setServices] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetch(`${SERVICES_API}?page=1&limit=20`)
      .then((res) => res.json())
      .then((json) => {
        if (Array.isArray(json?.data)) {
          setServices(json.data);
        }
      })
      .catch(() => {})
      .finally(() => setLoading(false));
  }, []);

  return (
    <div id="capabilities">
      <section className="service-section bg-white">
        <div className="divider"></div>

        <div className="container">
          <div className="row g-5">
            <div className="col-12 col-md-4">
              <div className="section-heading pe-lg-4">
                <div className="sub-title">
                  <img src="assets/img/core-img/hammer.png" alt="" />
                  Our Services
                </div>
                <h2>People do not Win Cases, Lawyers Do</h2>
                <Link className="btn btn-primary" to="/aboutus">
                  <span>
                    Read More <i className="ti ti-arrow-up-right"></i>
                  </span>
                  <span>
                    Read More <i className="ti ti-arrow-up-right"></i>
                  </span>
                </Link>
              </div>
            </div>

            <div className="col-12 col-md-8">
              <div className="swiper service-swiper-slider">
                <div className="swiper-wrapper">
                  {loading ? (
                    <div className="swiper-slide">
                      <div className="service-slide-card d-flex align-items-center justify-content-center" style={{ minHeight: 180 }}>
                        <span>Loading services…</span>
                      </div>
                    </div>
                  ) : (
                    services.map((s) => (
                      <Link
                        key={s.id}
                        to={`/servicedetails?id=${s.id}`}
                        className="swiper-slide"
                      >
                        <div className="service-slide-card">
                          <div className="title">{s.title}</div>
                          <p>{truncateText(s.summary, 140)}</p>
                          <div className="btn btn-link">
                            Read More <i className="ti ti-arrow-up-right"></i>
                          </div>
                        </div>
                      </Link>
                    ))
                  )}
                </div>
              </div>
            </div>

            {/* Service Navigation */}
            <div className="col-12">
              <div className="swiper-navigation-container service-swiper-slider-navigation">
                <div className="service-button-prev">
                  <i className="ti ti-arrow-left"></i>
                </div>
                <div className="service-button-next">
                  <i className="ti ti-arrow-right"></i>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="divider"></div>
      </section>
    </div>
  );
}

export default ServiceSection;
